

















































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { orderUsersModule } from '../store/modules/OrderUsers'; // ストアモジュール
import { ILoginUserInfo } from '../../store/dto/LoginUserInfo';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import axios from 'axios';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class UserChangePassword extends ApiAccessBase {
  // 共通パス
  private APP_PATH = Constants.KANRI_URL + '/user-info/password';

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'パスワード更新';
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['user_password_change']);
    const path = this.APP_PATH + '/init';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false);
  }

  private regist() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    const path = this.APP_PATH + '/update' + orderUsersModule.GET_PATH;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
    });
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    router.push({ name: 'userInfo' });
  }
}
